import { createAction } from '@reduxjs/toolkit';
import { CanvasPreviewSize } from './types';

export const setCanvasPreviewSize = createAction<CanvasPreviewSize>('preview/setCanvasPreviewSize');

export const setZoomLevel = createAction<number>('preview/setZoomLevel');
